import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import http from 'services/httpService';
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';

const ErrorReportModal = ({ show, onClose, errorDetails }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return 'N/A';
    return new Date(timestamp).toLocaleString();
  };

  const handleReport = async () => {
    setIsSubmitting(true);
    try {
      await http.post('/api/error_reports/', {
        message: errorDetails?.message || 'Unknown error',
        stack_trace: errorDetails?.stackTrace || null,
        endpoint: errorDetails?.endpoint || null,
        browser_info: {
          userAgent: navigator.userAgent,
          url: window.location.href,
          timestamp: errorDetails?.timestamp,
        },
      });
      displayGlobalMessage('Error report submitted successfully', 'success');
      onClose();
    } catch (err) {
      displayGlobalMessage('Failed to submit error report', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Error Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <strong>Error Details:</strong>
          <p className="text-danger mb-2" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
            {errorDetails?.stackTrace || errorDetails?.message || 'Unknown error'}
          </p>
        </div>
        <div className="mb-3">
          <strong>Occurred at:</strong>
          <p className="text-muted mb-0">{formatTimestamp(errorDetails?.timestamp)}</p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleReport} disabled={isSubmitting}>
          {isSubmitting ? 'Reporting...' : 'Report'}
        </Button>
        <Button variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorReportModal;
